import React, { useEffect } from "react";
import { OptionalUI } from "../Booking/OptionalParts/OptionalUI";
import { useAppState } from "../../Redux/ReduxHooks";
import { SdkLoadingState } from "./PayPalState";
import { Dispatch } from "../Dispatch";
import { MenuItem } from "@mui/material";
import { PayPal } from "./PayPal";
import { ContentURL, getContentUrl } from "../Utils/ContentURL";
import { BookingFlowTriggerSource } from "../UILogicControl/UILogicControlEntities";
import appstore from "../../appStore";
import { PayPalGuestTempPlaceholder } from "../Payment/PaymentEntities";

/** 
 * Renders the Add PayPal entry in the payment method entry in the booking form.
 * Only present when the feature is supported and the user doesn't already have PayPal.
 */
export const AddPayPalDropDownEntry: React.FC = () => {

    const isFeatureEnabled = useAppState(OptionalUI.AddPayPal);
    const hasPendingPayPalGuest = useAppState(OptionalUI.PendingPayPalGuest);
    const myPaymentMethods = useAppState(i => i.payment.AllCards);
    const sdkLoadStatus = useAppState(i => i.PayPal.LoadingStatus);
    const isCnpDisallowed = useAppState(OptionalUI.CnpDisallowedByMetered);
    const isPaymentSystemAvailable = useAppState(i => i.payment.IsPaymentSystemAvailable);

    // when the user opens the Payment dropdown very early
    useEffect(() => {
        if (sdkLoadStatus === SdkLoadingState.NotRequested) {
            Dispatch.PayPal.ReadyToLoad();
        }
    }, []);

    // not supported
    if (!isFeatureEnabled) return null;
    if (isCnpDisallowed) return null;
    if (!isPaymentSystemAvailable) return null;

    // already have PayPal
    if (myPaymentMethods.find(c => c.CardType === "PayPal")) return null;
    if (hasPendingPayPalGuest) return null;

    const isNotFullyLoaded = sdkLoadStatus !== SdkLoadingState.FinishedSuccess;

    let labelText: string = "PayPal";
    if (isNotFullyLoaded) labelText += " (Loading...)";

    return (
        <MenuItem className="cardMenuItem" value="#" disableGutters
            onClick={OnPayPalButtonClicked}
            disabled={isNotFullyLoaded}
        >
            <img className="cardSelectorCardImage" src={getContentUrl(ContentURL.images.CnpPaymentMethod.PayPal)} alt="PayPal icon" />
            <span className="cardSelectorCardName">{labelText}</span>
        </MenuItem>
    );
}

/** Event handler for clicking on the PayPal menu item. */
function OnPayPalButtonClicked(event: React.MouseEvent | React.TouchEvent) {

    // Prevent the default MUI Select behaviour on iOS, which can cause a page reload when selecting a virtual menu item (value="#") while Braintree hosted fields are present.
    event.preventDefault();

    const bookingFlowTrigger = appstore.getState().uiLogicControl.BookingFlowTrigger;

    // For the tracking SMS flow, the PayPal UI flow is deferred until the user clicks the confirmation button.
    if (bookingFlowTrigger === BookingFlowTriggerSource.TrackingSms) {
        Dispatch.PhoneToCnp.PaymentOption(PayPalGuestTempPlaceholder);
        Dispatch.UILogicControl.CloseCardSelectorDropdown();
        return;
    }

    Dispatch.UILogicControl.CloseCardSelectorDropdown();
    PayPal.RunAddPayPalUiFlow()
}
